import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CanActivateCondicaoPagamento } from './can-activate-condicao-pagamento';
import { CondicaoPagamentoComponent } from './condicao-pagamento.component';
import { CondicaoPagamentoFormComponent } from './form';


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateCondicaoPagamento],
                children: [
                    {path: '', component: CondicaoPagamentoComponent},
                    {path: 'novo', component: CondicaoPagamentoFormComponent},
                    {path: ':id', component: CondicaoPagamentoFormComponent}
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateCondicaoPagamento
    ]
})
export class CondicaoPagamentoRoutingModule { }
